import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
  useSelector,
  setFormValue,
} from '../../../store.js'
import ConfirmModal from './ConfirmModal.js'
import deferPromise from '../../deferPromise.js'

const MODAL_FORM = 'confirm_message_modal'

export function showConfirmMessageModal({
  message,
  Message,
  confirmValue = true,
  cancelValue = false,
  hideConfirm = false,
  hideCancel = false,
  errorsSelector,
  onResolve = () => {},
  ...props
}) {
  const deferredPromise = deferPromise()

  setForm(MODAL_FORM, {
    message,
    Message,
    confirmValue,
    cancelValue,
    hideConfirm,
    hideCancel,
    errorsSelector,
    onResolve,
    ...props,
    deferredPromise,
  })

  return deferredPromise.promise
}

export function updateModalForm(...args) {
  updateForm(MODAL_FORM, ...args)
}

export function setModalFormValue(...args) {
  setFormValue(MODAL_FORM, ...args)
}

export async function closeModal(outcome = null) {
  const form = modalFormSelector(getState())

  try {
    updateModalForm({isSaving: true, error: null})

    await form.onResolve({
      outcome,
      form,
      updateModalForm,
      setModalFormValue,
      modalFormSelector,
    })

    removeForm(MODAL_FORM)

    form.deferredPromise.resolve(outcome)
  } catch (err) {
    updateModalForm({isSaving: false, error: err.message})
  }
}

export function modalFormSelector(state) {
  return formsSelector(state)[MODAL_FORM]
}

export function errorsSelector(state) {
  const {errorsSelector} = modalFormSelector(state)

  if (errorsSelector) {
    return errorsSelector(state, {formName: MODAL_FORM})
  } else {
    return {}
  }
}

function ConfirmMessageModal({form}) {
  const {message, Message, confirmValue, cancelValue, ...props} = form

  const errors = useSelector(errorsSelector)

  return (
    <ConfirmModal
      title="Confirm"
      modalSize="sm"
      onConfirm={props.hideConfirm ? null : () => closeModal(confirmValue)}
      onCancel={props.hideCancel ? null : () => closeModal(cancelValue)}
      isDisabled={errors.preventSave}
      {...props}
    >
      {message}
      {Message && (
        <Message
          form={form}
          errors={errors}
          updateModalForm={updateModalForm}
          setModalFormValue={setModalFormValue}
        />
      )}
    </ConfirmModal>
  )
}

export default onlyIfForm(ConfirmMessageModal, modalFormSelector)
